import LandingPageJumbotron from '@/app/components/LandingPage/LandingPageJumbotron';

const MetabolicHealthJumbotron = () => {
  return (
    <section className="pb-4 lg:py-8" data-cy="metabolic-health-jumbotron">
      <LandingPageJumbotron
        description="metabolic_health_jumbotron_description"
        title="metabolic_health"
        theme="mustard"
      />
    </section>
  );
};

export default MetabolicHealthJumbotron;
